import * as React from "react";
import { difference, isFinite, pick } from "lodash/fp";
import { Filter } from "./Filter/Filter";
// TODO use TS types updated for version 16. But I also have some changes
// I made for SVG attributes that need to get merged.
const Fragment = React["Fragment"];
// These are the white-listed SVG tag names that kaavio can render
// TODO either let symbols override these, or else check in CLI to notify user of clobbering.
const SVG_TAG_NAMES = [
    "circle",
    "ellipse",
    "line",
    "path",
    "polygon",
    "polyline",
    "rect"
];
// These are the white-listed SVG attribute names for kaavio, all lowerCamelCased
const SVG_ATTRIBUTES = [
    "cx",
    "cy",
    "d",
    "height",
    "id",
    "fill",
    "fillOpacity",
    "fillRule",
    "pathLength",
    "points",
    "r",
    "rx",
    "ry",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "style",
    "transform",
    "width",
    "x",
    "x1",
    "x2",
    "y",
    "y1",
    "y2"
];
const SVG_STYLE_ATTRIBUTES = [
    "fill",
    "fillOpacity",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth"
];
const ICON_ONLY_ATTRIBUTES = difference(SVG_ATTRIBUTES, SVG_STYLE_ATTRIBUTES);
// TODO only x and y are corrected for translation of container. All of these are not: x1, x2, y1, y2, d, points, cx, cy! Fix this.
/**
 * Node is a rectangle within a Kaavio diagram.
 * It can be mapped to other pathway elements. For example, in PVJS this is mapped to metabolites and proteins.
 */
export class Node extends React.Component {
    constructor(props) {
        super(props);
    }
    componentWillReceiveProps(nextProps) {
        // TODO this might be slower than it needs to be. Can we set only a subset?
        //const nextState = this.getStateFromProps(nextProps);
        //this.setState(nextState);
    }
    renderIcon() {
        const { props } = this;
        const { fill, rx, ry, strokeStyle, strokeWidth, children, stroke, fillOpacity, drawAs, filters, height, id, parentFill, style, type, width } = props;
        // If drawAs specifies an SVG element, render icon as the SVG element.
        // Otherwise, render as a symbol via a use tag.
        const TagName = SVG_TAG_NAMES.indexOf(drawAs) > -1 ? drawAs : "use";
        const iconOnlyProps = pick(ICON_ONLY_ATTRIBUTES, props);
        const firstChildStyleProps = pick(SVG_STYLE_ATTRIBUTES, props);
        if (!!id) {
            iconOnlyProps.id = `${id}-icon`;
            iconOnlyProps.key = `${id}-icon`;
        }
        if (TagName === "use") {
            // TODO href is now preferred, but it doesn't work in Safari. Why?
            //iconOnlyProps.href = "#" + drawAs;
            iconOnlyProps.xlinkHref = "#" + drawAs;
        }
        if (iconOnlyProps.hasOwnProperty("x")) {
            // correcting for translation of container.
            iconOnlyProps.x = "0";
            iconOnlyProps.y = "0";
        }
        // TODO do we need to specify these as px?
        if (!!width && isFinite(parseFloat(width))) {
            iconOnlyProps.width = width + "px";
        }
        if (!!height && isFinite(parseFloat(height))) {
            iconOnlyProps.height = height + "px";
        }
        // TODO: for icons with strokeStyle of double, it appears the actual stroke
        // width we're currently getting is closer to 4x, but it should be 2x or 3x.
        // TODO: we're getting box-sizing: border-box behavior for a 200x100 rect
        // with a 3px double-line stroke, but it's slightly off for a 40x40 rect
        // with same stroke.
        const actualStrokeWidth = strokeStyle === "double" ? strokeWidth * 4 : strokeWidth;
        if (width + actualStrokeWidth > 0 && height + actualStrokeWidth > 0) {
            const scaleX = width / (width + actualStrokeWidth);
            const scaleY = height / (height + actualStrokeWidth);
            const translateX = width / 2;
            const translateY = height / 2;
            iconOnlyProps.transform = `matrix(${scaleX}, 0, 0, ${scaleY}, ${translateX -
                scaleX * translateX}, ${translateY - scaleY * translateY})`;
        }
        if (!!fill) {
            firstChildStyleProps.fillOpacity = isFinite(fillOpacity)
                ? fillOpacity
                : 1;
        }
        if (!!strokeWidth) {
            firstChildStyleProps.strokeWidth = strokeWidth;
        }
        if (strokeStyle === "dashed") {
            firstChildStyleProps.strokeDasharray = "5,3";
        }
        if (rx) {
            iconOnlyProps.rx = rx;
        }
        if (ry) {
            iconOnlyProps.ry = ry;
        }
        return (React.createElement(Filter, { filters: filters, strokeStyle: strokeStyle, childTag: TagName, parentFill: parentFill, childOnlyProps: Object.assign(Object.assign({}, iconOnlyProps), { className: "Icon" }), firstChildStyleProps: firstChildStyleProps }));
    }
    render() {
        const { children } = this.props;
        return (React.createElement(Fragment, null,
            this.renderIcon(),
            children));
    }
}
//# sourceMappingURL=data:application/json;base64,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